import timesheetApi from "api/timesheet";
import { roles, typesTimesheet, typesTimesheetLabel } from "constants/index";
import { Button, Col, Form, Modal, Row, Select } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function ModalCreated({
  openModal,
  setOpenModal,
  dataModal,
  openNotificationWithIcon,
  getTimesheet,
}) {
  const onCancel = () => {
    form.resetFields();
    setOpenModal(false);
  };

  const { t } = useTranslation()

  const [form] = Form.useForm();

  const onFinish = async (values) => {
    const payload = {
      userWork: dataModal.userWorkId,
      logDate: dataModal.logDate,
      type: values.type,
    };
    try {
      if (!dataModal.id) {
        const res = await timesheetApi.createTimesheet(payload);
        if (res.success) {
          if (dataModal.role == roles.springer) {
            window.location.reload();
          }
          openNotificationWithIcon("success", t('notification'), t('createDayOffSuccess'));
          onCancel();
          getTimesheet();
        }
      } else {
        const res = await timesheetApi.updateTimesheet(dataModal.id, payload);
        if (res.success) {
          if (dataModal.role == roles.springer) {
            window.location.reload();
          }
          openNotificationWithIcon("success", t('notification'), t('updateTimeSheetSuccess'));
          onCancel();
          getTimesheet();
        }
      }
    } catch (error) {
      openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
    }
  };

  const typeTimesheetOption = Object.keys(typesTimesheetLabel)
    .filter((key) => key !== typesTimesheet.work)
    .map((key) => ({
      value: key,
      label: t(`${typesTimesheetLabel[key]}`),
    }));

  useEffect(() => {
    form.setFieldValue('type', dataModal.type?.toString())
  }, [dataModal])

  return (
    <Modal
      title={`${dataModal.id ? t('changeTimesheet') : t('createDayOff')}: ${dataModal.logDate
        }`}
      centered
      open={openModal}
      footer={null}
      onCancel={onCancel}
      width={400}
      destroyOnClose
    >
      <p style={{ margin: "10px 0px", fontWeight: "bold" }}>{t('fullName')}: {dataModal.user}</p>
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item
          name="type"
          label={t('dayOffType')}
          required
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select options={typeTimesheetOption} allowClear defaultValue={dataModal.type} />
        </Form.Item>
        <Row gutter={16}>
          <Col span={8} offset={4}>
            <Form.Item>
              <Button style={{ width: "100%" }} htmlType="submit">
                Ok
              </Button>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Button style={{ width: "100%" }} onClick={onCancel}>
              {t('cancel')}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
